<template>
  <div class="container-plan">
    <div class="price-header">
      <img loading="lazy" src="@/assets/icons/header-price.svg"
      :alt="$t('alt.prices.header-price')">
      <div class="plan-name ms-3">
        <h4 class="font-montserrat-b mb-4 text-center" v-html="getName(item.nameTranslations[selectLanguage])"></h4>
      </div>
    </div>

    <div class="price-card p-4" style="height: calc(100% - 350px)">
      <div class="text-center d-flex flex-column justify-content-between" style="min-height: 170px">
        <p class="m-0" v-html="item.descriptionTranslations[selectLanguage]"></p>
        <div class="d-flex justify-content-center">
          <ButtonHover
            class="mb-4"
            :btn-text="$t('prices.hire-now-button')"
            background-color="#637056"
            @click="openContactForm()"
          />
        </div>
      </div>

      <div class="card-body">
        <div v-for="(item, index) of item?.priceSpecifications" :key="index">
          <p class="m-0">{{ $t(`prices.priceSpecifications.${item.key}`) }}</p>
          <p class="font-montserrat-b"><b>{{ getValueSpecificationPrice(item.value) }} {{ $t(`prices.${item.description}`) }}</b></p>
        </div>

        <div v-for="item of item?.access" :key="item.cost">
          <CheckText :item="item" />
        </div>
      </div>

      <div v-if="item?.bestSeller" class="container-best-seller">
        <img loading="lazy" class="w-100" src="@/assets/icons/best-seller.svg"
        :alt="$t('alt.prices.logo-best-seller')">
      </div>
    </div>

    <div class="container-price">
      <div class="circle-img font-montserrat-b">
        <h2 class="m-0" v-if="!item?.contactForPrice">
          ${{ item.price }}
          <p class="text-center m-0" style="font-size: 22px">USD</p>
        </h2>
        <p v-else class="text-center m-0" v-html="$t('prices.contact-for-price')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonHover from '@/components/ButtonHover.vue'
import CheckText from '@/components/CheckText.vue'
import { useRouter } from 'vue-router'

export default {
  props: {
    selectLanguage: {
      type: String,
      default: 'en'
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ButtonHover,
    CheckText
  },
  setup(props) {
    const router = useRouter()
    const openContactForm = () => {
      router.push({
        name: 'contact',
        hash: '#form-contact'
      })
    }

    const getName = (name) => {
      const split = name.split(' ')
      if (split.length > 1) {
        return `${split[0]} <br> ${split[1]}`
      }
      return split[0]
    }

    const getValueSpecificationPrice = (value) => {
      if (!value || value === '') return ''

      if (props.selectLanguage === 'en' && value.includes('$')) {
        return `${value} USD`
      }

      if ((props.selectLanguage === 'es' || props.selectLanguage === 'pt') && value.includes('$')) {
        const val = value.slice(1)
        return `${val}$`
      }

      return value
    }

    return {
      openContactForm,
      getValueSpecificationPrice,
      getName
    }
  }
}
</script>

<style scoped>
.price-header {
  display: grid;
  place-items: center;
  position: relative
}

.price-header img {
  object-fit: fill;
  width: 100%;
}

.price-header .plan-name {
  position: absolute;
}

.price-card {
  background-color: var(--primary-color);
  color: var(--white);
  border-radius: 10px;
  font-family: var(--montserrat-medium);
  position: relative;
  -webkit-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 15px -1px rgba(0,0,0,0.75);
}

.container-price {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

.circle-img {
  position: relative;
  background-image: url(../../../assets/icons/circle-price.svg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
}

.circle-img h1 {
  margin-top: 45px;
  margin-right: 10px;
}

.container-best-seller {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 80px;
  height: 80px;
}

.button {
  padding: 5px 25px
}

@media screen and (min-width: 300px) and (max-width: 1024px)  {
  .container-plan {
    margin-bottom: 55%;
  }
}
</style>
